import React from 'react';
import PropTypes from 'prop-types';
import { Components } from 'versafleet-core';
import Panel from './panel';

class HeaderProfileButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false,
    };
  }

  _toggleDropdown = (showDropdown) => {
    this.setState({ showDropdown });
  }

  _renderPanel() {
    return (
      <Panel
        activatorUser={this.props.activatorUser}
        closePanel={this.props.closePanel}
        content={this.props.content}
        name={this.props.name}
      />
    );
  }

  render() {
    return (
      <Components.ButtonDropdown
        className="vf-header-profile"
        iconClassName="versa-user"
        showDropdown={this.state.showDropdown}
        toggleDropdown={this._toggleDropdown}
      >
        {this._renderPanel()}
      </Components.ButtonDropdown>
    );
  }
}

HeaderProfileButton.displayName = 'Header Profile Button';

HeaderProfileButton.propTypes = {
  activatorUser: PropTypes.string,
  closePanel: PropTypes.func,
  content: PropTypes.arrayOf(PropTypes.shape()),
  name: PropTypes.string,
};

HeaderProfileButton.defaultProps = {
  activatorUser: null,
  closePanel: null,
  content: [],
  name: null,
};

export default HeaderProfileButton;
